import {
  getGuestCountTableColumn,
} from '../utils/columns'
import {
  getBrandTableColumn,
  getStatusTableColumn,
  getEnabledTableColumn,
  getNameDescriptionTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'name',
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.name }</side-page-trigger>
          )
        },
      }),
      getBrandTableColumn({ field: 'provider', title: i18n.t('scope.text_504') }),
      getStatusTableColumn({ field: 'connect_status', statusModule: 'cloudaccount', title: i18n.t('common_398') }),
      getStatusTableColumn({ statusModule: 'cloudaccountHealthStatus', title: i18n.t('scope.text_544'), field: 'cloudaccount_detail.health_status', minWidth: 90 }),
      getGuestCountTableColumn(),
      getEnabledTableColumn({ field: 'enable_auto_sync', title: i18n.t('scope.text_545'), minWidth: 90 }),
      {
        field: 'cloudaccount_detail.last_auto_sync',
        title: i18n.t('scope.text_572'),
        minWidth: 70,
        showOverflow: 'title',
        slots: {
          default: ({ row }) => {
            if (!row.cloudaccount_detail) return '-'
            if (row.cloudaccount_detail.sync_status !== 'idle') { // 表示正在同步中
              return [
                <status status={ row.cloudaccount_detail.sync_status } statusModule='cloudaccountSyncStatus' />,
              ]
            } else {
              const time = this.$moment(row.cloudaccount_detail.last_sync)
              if (time) {
                return time.fromNow()
              } else {
                return '-'
              }
            }
          },
        },
      },
      getCopyWithContentTableColumn({
        field: 'enterprise_name',
        title: i18n.t('scope.text_503'),
        minWidth: 200,
      }),
      {
        field: 'subscription.currency',
        title: i18n.t('common_405'),
        minWidth: 70,
        formatter: ({ row }) => {
          if (!row.billing_subscription || !row.billing_subscription.currency) return '-'
          const cellValue = row.billing_subscription.currency
          if (cellValue === 'CNY') return i18n.t('bill.text_30')
          return i18n.t('scope.text_469')
        },
      },
      {
        field: 'subscription.paid_currency',
        title: i18n.t('scope.text_449'),
        minWidth: 80,
        formatter: ({ row }) => {
          if (!row.billing_subscription || !row.billing_subscription.paid_currency) return '-'
          const cellValue = row.billing_subscription.paid_currency
          if (cellValue === 'CNY') return i18n.t('bill.text_30')
          return i18n.t('scope.text_469')
        },
      },
      {
        field: 'subscription.billing_cycle',
        title: i18n.t('scope.text_488'),
        minWidth: 80,
        formatter: ({ row }) => {
          if (!row.billing_subscription || !row.billing_subscription.billing_cycle) return '-'
          const cellValue = row.billing_subscription.billing_cycle
          const val = cellValue.substr(0, cellValue.length - 1)
          const obj = {
            D: i18n.t('scope.text_489'),
            M: i18n.t('scope.text_490'),
            Y: i18n.t('scope.text_491'),
          }
          return val + obj[cellValue.charAt(cellValue.length - 1)]
        },
      },
      {
        field: 'subscription.grace_period',
        title: i18n.t('scope.text_492'),
        minWidth: 100,
        formatter: ({ row }) => {
          if (!row.billing_subscription || !row.billing_subscription.grace_period) return '-'
          const cellValue = row.billing_subscription.grace_period
          const val = cellValue.substr(0, cellValue.length - 1)
          const obj = {
            D: i18n.t('scope.text_489'),
            M: i18n.t('scope.text_490'),
            Y: i18n.t('scope.text_491'),
          }
          return val + obj[cellValue.charAt(cellValue.length - 1)]
        },
      },
      {
        field: 'subscription.time_zone',
        title: i18n.t('scope.text_493'),
        minWidth: 150,
        formatter: ({ row }) => {
          if (!row.billing_subscription) return '-'
          return row.billing_subscription.time_zone
        },
      },
    ]
  },
}
